export const SOCIAL_SHARE = {
  FACEBOOK_BASE_URL: "https://www.facebook.com/sharer/sharer.php",
  TWITTER_BASE_URL: "https://twitter.com/intent/tweet",
  HASHTAG: "tamda",
} as const

export const buildFacebookShareUrl = (url: string): string => {
  const params = new URLSearchParams({
    u: url,
    hashtag: `#${SOCIAL_SHARE.HASHTAG}`,
    quote: `#${SOCIAL_SHARE.HASHTAG}`,
  })
  return `${SOCIAL_SHARE.FACEBOOK_BASE_URL}?${params.toString()}`
}

export const buildTwitterShareUrl = (url: string): string => {
  const params = new URLSearchParams({
    url: url,
    hashtags: SOCIAL_SHARE.HASHTAG,
  })
  return `${SOCIAL_SHARE.TWITTER_BASE_URL}?${params.toString()}`
}

export const openShareWindow = (url: string, width: number = 600, height: number = 400): void => {
  if (typeof window === "undefined") return

  // Lấy vị trí và kích thước của cửa sổ browser hiện tại
  const windowLeft = window.screenX || window.screenLeft || 0
  const windowTop = window.screenY || window.screenTop || 0
  const windowWidth = window.outerWidth || window.innerWidth || 800
  const windowHeight = window.outerHeight || window.innerHeight || 600

  // Tính toán vị trí để popup nằm giữa cửa sổ browser hiện tại
  const left = Math.round(windowLeft + (windowWidth - width) / 2)
  const top = Math.round(windowTop + (windowHeight - height) / 2)

  const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no`
  window.open(url, "_blank", windowFeatures)
}

